const parse = (val) => {
  if (!val) return null;
  if (typeof val === "string") {
    try { val = JSON.parse(val); } catch { return null; }
  }
  const item = Array.isArray(val) ? val[0] : val;
  return item && (item.templateId ?? item.TemplateId) ? item : null;
};

// tokenData is rewritten on every patient/location switch, so it is the source of truth;
// the standalone session key is only a fallback.
export function getRateReviewTemplate() {
  try {
    const td = JSON.parse(sessionStorage.getItem("tokenData") || "{}");
    const fromToken = parse(td.rateReviewTemplate ?? td.RateReviewTemplate);
    if (fromToken) return fromToken;
  } catch { /* fall through */ }
  return parse(sessionStorage.getItem("tokenRateReviewTemplate"));
}
